import { useRef } from 'react';
import './PersonUpload.css';

function PersonUpload({ personImage, setPersonImage }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPersonImage(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const getPreviewUrl = () => {
    if (personImage) {
      return URL.createObjectURL(personImage);
    }
    return null;
  };

  return (
    <div className="upload-section person-upload">
      <h2 className="section-title">Person</h2>
      <button className="upload-button" onClick={handleClick}>
        <span className="upload-icon">⬆</span>
        Upload/Click Photo
      </button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/*"
        style={{ display: 'none' }}
      />
      <div className="preview-container">
        {getPreviewUrl() ? (
          <img src={getPreviewUrl()} alt="Person preview" className="preview-image" />
        ) : (
          <div className="preview-placeholder"></div>
        )}
      </div>
    </div>
  );
}

export default PersonUpload;
